module.exports = __webpack_public_path__ + "img/auth-logo.43576e63.jpeg";